"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.threads.title': '线程',
    'whatsapp.threads.count': '总计',
    'whatsapp.threads.noThreads': '未找到线程。',
    'whatsapp.threads.noLogs': '此线程中没有跟踪日志。',
    'whatsapp.threads.selectThread': '选择一个线程以查看其跟踪日志。',
    'whatsapp.threads.showFinished': '显示已完成',
    'whatsapp.threads.finished': '已完成',
    'whatsapp.threads.finish': '完成',
    'whatsapp.threads.reopen': '重新打开',
    'whatsapp.threads.back': '返回',
    'whatsapp.threads.confirmFinish': '将此线程标记为已完成？',
    'whatsapp.threads.finishFailed': '无法完成线程。',
    'whatsapp.threads.source.group': '群组',
    'whatsapp.threads.source.email': '电子邮件',
    'whatsapp.threads.source.dm': '私信',
};
